import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Fullscreen, Footer, Section } from '../Common/Modal/Fullscreen';
import { tubeSpinner, minipodIconPage } from '../../assets/Images';
import {
  ContentPanel,
  FooterWrapper,
  FPTLogo,
  HeaderIcon,
  HeaderPanel,
  McCheckbox,
  McOption,
  Message,
  OptionLabel,
  OptionsPanel,
  PollingCard,
  Spinner,
  Title,
} from './Elements';
import { CDN_ASSET_URL } from '../../services/AssetsService';
import { Button, ButtonLink } from '../Common/Button';
import pollingService, { PollingState } from './PollingService';
import Events from './Events';
import { TabObserver } from '../../util/TabObserverUtil';
import log from '../../services/LogService';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function Processing(props: any) {

  const { emitter, measurementId, sessionId } = props;
  const [ isPolling, setPolling ] = useState(false);
  const [ donePolling, setDonePolling ] = useState(null);
  const [ hasOrthopedicsOrPain, setOrthopedicsOrPain ] = useState(false);
  const params = new URLSearchParams();
  params.append('fpt-measurement', measurementId);
  params.append('fpt-session', sessionId);
  params.append('fpt-measuretype', 'STATIC');
  params.append('hasOrthopedicsOrPain', String(hasOrthopedicsOrPain));
  const [ mcParams, setMcParams ] = useState(params.toString());

  const handleStartMinipod = () => {
    console.log('start minipod clicked');
  };

  const handleCancelPolling = () => {
    console.log('cancel polling clicked');
    pollingService.stop();
    setPolling(false);
    emitter.emit(Events.onMcPollingCancelled);
  };

  const handleOrthopedicsOrPainSelect = () => {
    const newVal = !hasOrthopedicsOrPain;
    setOrthopedicsOrPain(newVal);
    console.log('has orthopedics or pain', newVal);
    const meaType = newVal ? 'DYNAMIC' : 'STATIC';
    params.set('fpt-measuretype', meaType);
    params.set('hasOrthopedicsOrPain', String(newVal));
    setMcParams(params.toString());
  }

  const startPolling = () => {
    setPolling(true);
    return pollingService.poll(measurementId, sessionId);
  };

  useEffect(() => {
    const obs = new TabObserver();
    const promise = obs.waitForPageStateChange().then(() => startPolling());
    setDonePolling(promise);
  }, []);

  useEffect(() => {

    if (isPolling && donePolling) {
      console.log('Polling started');
      emitter.emit(Events.onMcPollingStart, mcParams);

      log.info(`on polling end`, donePolling);

      donePolling.then(
        outcome => emitter.emit(Events.onMcPollingDone, {
          frame: outcome,
          params: mcParams,
        }))
        .catch(err => {
          if (err === PollingState.CANCELLED) {
            log.warn(`Polling cancelled`);
            return;
          }
          emitter.emit(Events.onMcPollingError, err);
        });
    }

  }, [isPolling, donePolling]);

  return (
    <Fullscreen emitter={emitter} isClosable={false} className="fpt-gradient">
      { !isPolling &&
      <ContentPanel>
        <FPTLogo src={CDN_ASSET_URL + '/logos/fpt_logo_splashscreen.png'} />
        <HeaderPanel>
          <HeaderIcon src={minipodIconPage}></HeaderIcon>
          <Title>
            <FormattedMessage id="lp.hartmann.minipod.title" />
          </Title>
          <Message>
            <FormattedMessage id="lp.hartmann.minipod.subtitle" />
          </Message>
        </HeaderPanel>
        <OptionsPanel>
          <McOption>
            <OptionLabel>
              <FormattedMessage id="lp.hartmann.minipod.option.orthopedics-or-pain" />
            </OptionLabel>
            <McCheckbox
              className={hasOrthopedicsOrPain ? 'active' : ''}
              onClick={handleOrthopedicsOrPainSelect} />
          </McOption>
        </OptionsPanel>
      </ContentPanel>
    }
    { isPolling &&
    <ContentPanel>
      <FPTLogo src={CDN_ASSET_URL + '/logos/fpt_logo_splashscreen.png'} />
      <HeaderPanel>
        <HeaderIcon src={minipodIconPage}></HeaderIcon>
        <Title>
          <FormattedMessage id="lp.hartmann.minipod.polling.title" />
        </Title>
        <Message>
          <FormattedMessage id="lp.hartmann.minipod.polling.subtitle" />
        </Message>
      </HeaderPanel>
      <Spinner src={tubeSpinner} />
    </ContentPanel>
  }


      <FooterWrapper>
        <Footer className="disclaimer">
          <Section>
          { !isPolling &&
            <ButtonLink
              href = {`unitydl://mylink?${mcParams}`}
              onClick={ handleStartMinipod } type="button"
              className="wide-primary">
              Start
            </ButtonLink>
          }
          { isPolling &&
            <Button
              onClick={ handleCancelPolling } type="button"
              className="wide-secondary">
              <FormattedMessage id="lp.hartmann.minipod.cancel" />
            </Button>
          }
          </Section>
          <Section>
            <FormattedMessage id="drv.splashscreen.footer"
              values={{
                policy: (chunks) => <a href="https://footprinttech.de/privacy-policy-webapp/" target="_blank">{chunks}</a>,
                tos: (chunks) => <a href="https://footprinttech.de/terms-of-use-webapp/" target="_blank">{chunks}</a>
              }} />
          </Section>
          <Section>
            <FormattedMessage id="drv.splashscreen.imprint"
              values={{
                imp: (chunks) => <a href="https://footprinttech.de/imprint-webapp/" target="_blank">{chunks}</a>,
              }} />
          </Section>
        </Footer>
      </FooterWrapper>
    </Fullscreen>
  );
}
